import { InjectionToken } from '@angular/core';

export interface CustomFormatter {
  supports(data: unknown): boolean;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  format(data: any): Partial<any>;
}

export const CUSTOM_FORMATTERS = new InjectionToken<CustomFormatter[]>(
  'CUSTOM_FORMATTERS'
);
